
const LoadingAdmin = () => {
  return (
    <>
    <div className="mb-6 lg:my-12 container px-6 mx-auto flex flex-col md:flex-row items-start md:items-center justify-between pb-4 border-b border-gray-300">
      <div>
        <h4 className="text-2xl font-bold leading-tight text-gray-800 dark:text-gray-100">Carregando...<small></small> </h4>
      </div>
      <div className="mt-6 md:mt-0">
        
      </div>
    </div>
    <div className="bg-white shadow px-4 md:px-10 pt-4 md:pt-7 pb-5 overflow-y-auto"></div>
    </>
  )
}

export default LoadingAdmin